import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'icon']

  connect() {
    this.buttonIcon = this.iconTarget.className
  }

  copy() {
    navigator.clipboard.writeText(this.inputTarget.value)
    this.animate()
  }

  animate() {
    this.copyingIcon()
    setTimeout(() => this.copiedIcon(), 500)
    setTimeout(() => this.originalIcon(), 1000)
  }

  copyingIcon() {
    this.iconTarget.className = 'fa-solid fa-spinner fa-pulse'
  }

  copiedIcon() {
    this.iconTarget.className = 'fa-solid fa-check'
  }

  originalIcon() {
    this.iconTarget.className = this.buttonIcon
  }
}
